/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_6c2f35f0"]'><div :class='["toast-with-mask-demo"]'><cube-button @_click="clickToast">Toast - with mask</cube-button><cube-toast txt="遮罩层" :mask="(true)" :maskFadeTransition="(true)" ref="__mpx_ref_toast__"></cube-toast></div></div></template>
/* styles */
/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_6c2f35f0"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_6c2f35f0"}
  /** script content **/
  require("./toast-with-mask.mpx.js?isComponent&outputPath=components%2Ftoast-with-mask6c2f35f0%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./toast-with-mask.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Ftoast-with-mask6c2f35f0%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_6c2f35f0"],
    ctorType: "component",
    outputPath: "components/toast-with-mask6c2f35f0/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-button':getComponent(require("../../../packages/mpx-cube-ui/src/components/button/index.mpx?isComponent&outputPath=components%2Findex7752a2b9%2Findex")),'cube-toast':getComponent(require("../../../packages/mpx-cube-ui/src/components/toast/index.mpx?isComponent&outputPath=components%2Findex7b472558%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>